export const PATIENT_RECORD_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
} as const;

export type PatientRecordStatus =
  (typeof PATIENT_RECORD_STATUS)[keyof typeof PATIENT_RECORD_STATUS];

export interface PatientRecordInsurer {
  id: number;
  globalId: number | string | null;
  name: string;
}

export interface PatientRecordContract {
  id: number;
  code: string;
  title: string;
  status: string;
  insurer: PatientRecordInsurer | null;
}

export interface PatientRecordField {
  key: string;
  label: string;
  type: string;
  required: boolean;
  active?: boolean;
  value: unknown;
}

export interface PatientRecordAmounts {
  provisional: number | null;
  definitive: number | null;
  consumed: number | null;
  currency: string;
}

export interface PatientRecord {
  id: number;
  code: string;
  status: PatientRecordStatus;
  active: boolean;
  patientId: number;
  episodeId: number | null;
  contract: PatientRecordContract | null;
  selectedRate: { id?: number; amount?: number } | null;
  amounts: PatientRecordAmounts | null;
  appointmentCount: number;
  documentCount: number;
  fields: PatientRecordField[];
  values: Record<string, unknown>;
  requiredComplete: boolean;
  closedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetPatientRecordsParams {
  contractId?: number;
  status?: string;
}

export interface GetActivePatientRecordParams {
  contractId?: number;
}
